export default "__VITE_ASSET__DYfZLbuX__"